import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Comparison from "./components/Comparison";
import Industries from "./components/Industries";
import Hardware from "./components/Hardware";
import Integrations from "./components/Integrations";
import FAQ from "./components/FAQ";
import Signup from "./components/Signup";
// import Signup from "./components/Signup_Simple";

function App() {
  return (
    <div className="bg-white wrap text-slate-900 antialiased">
      <Header />
      <Hero />
      <Features />
      <Comparison />
      <Industries />
      <Hardware />
      <Integrations />
      <FAQ />
      <Signup />
      <Footer />
    </div>
  );
}

export default App;
